import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { Subscription } from "rxjs";
import { LaunchDarklyService } from "../../launchDarkly/launchDarkly.service";

@Component({
  selector: "student-comp-table-fixed-col-header",
  templateUrl: "./student-comp-table-fixed-col-header.component.html",
  styleUrls: ["./student-comp-table-fixed-col-header.component.scss"],
})
export class StudentCompTableFixedColHeaderComponent implements OnInit {
  @Input() school;
  @Input() selectedAll: boolean;
  @Input() hasStudentSelected: boolean;
  @Output() selectAllChange = new EventEmitter();
  @Output() addGroupClicked = new EventEmitter();
  @Output() addStudentsToGroupClicked = new EventEmitter();
  @Output() removeStudentsFromGroupClicked = new EventEmitter();

  // Feature flagging student group functionality
  flagSubscription: Subscription;
  showStudentGroups: boolean = true;

  constructor(public launchDarklyService: LaunchDarklyService) {
    this.initFlags(launchDarklyService);
    this.flagSubscription = launchDarklyService.flagChange.subscribe(() =>
      this.initFlags(launchDarklyService)
    );
  }

  ngOnInit() {}

  ngOnDestroy() {
    this.flagSubscription.unsubscribe();
  }

  initFlags(launchDarklyService: LaunchDarklyService) {
    this.showStudentGroups = launchDarklyService.getFlag(
      "mosaic-ui-show-student-groups"
    );
  }
}
